import { usePromiseTracker } from "react-promise-tracker";

const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker();
  if (!promiseInProgress) return null;
  return (
    <div className="ef-loading-overlay">
      <div className="ef-loading__spinner" />
    </div>
  );
};

export default LoadingIndicator;
